import def from './default';
import development from './development';
import developmentLocal from './development.local';
import production from './production';
import testing from './testing';
import testingLocal from './testing.local';

const isTestHostname = window.location.hostname.startsWith('test.');
const apiLocal = parseInt(process.env.API_LOCAL) === 1;

const env = isTestHostname ? 'testing' : process.env.NODE_ENV || 'testing';

const configEnv = env + (apiLocal ? '.local' : '');

function isPlainObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

// Deep clone for plain objects and arrays. Other values are returned as-is.
function clone(value) {
  if (Array.isArray(value)) return value.map(clone);
  if (isPlainObject(value)) {
    const result = {};
    Object.keys(value).forEach((key) => {
      result[key] = clone(value[key]);
    });
    return result;
  }
  return value;
}

// Deep merge. Returns a NEW object, inputs are not changed.
// - plain objects are merged key by key
// - arrays and other values from envConfig replace the default value
function merge(defConfig, envConfig) {
  const result = clone(defConfig);
  Object.keys(envConfig).forEach((key) => {
    if (isPlainObject(result[key]) && isPlainObject(envConfig[key])) {
      result[key] = merge(result[key], envConfig[key]);
    } else {
      result[key] = clone(envConfig[key]);
    }
  });
  return result;
}

function getBaseConfig(currentEnv) {
  switch (currentEnv) {
    case 'development':
      return merge(def, development);
    case 'development.local':
      return merge(getBaseConfig('development'), developmentLocal);
    case 'testing':
      return merge(def, testing);
    case 'testing.local':
      return merge(getBaseConfig('testing'), testingLocal);
    case 'production':
      return merge(def, production);
    default:
      return clone(def);
  }
}

class Config {
  config = {};

  constructor() {
    this.config = getBaseConfig(configEnv);

    this.config.env = env;
  }

  set(key, value) {
    this.config[key] = value;
  }

  get(key) {
    return this.config[key];
  }

  apiHost() {
    return this.config.httpApi[0];
  }

  tusHost() {
    return this.config.tus[0];
  }
}

const config = new Config();
window.lifeappConfig = config;

export default config;
